import {
    fetchApiHeaders,
    globalURL
} from "../../helpers/constants";


const getHomeData = () => dispatch => {
    dispatch({
        type: "GET_HOME"
    })

    fetch(globalURL + "/banner/getAllBanners", {
        method: 'POST',
        headers: {
            ...fetchApiHeaders.POST
        }
    })
        .then((result) => result.json())
        .then(async (result) => {
            if (result.success) {
                dispatch({
                    type: "FETCH_HOME",
                    payload: result.data
                })
            } else {
                dispatch({
                    type: "ERROR_HOME",
                    payload: result
                })
            }
        })
        .catch((error) => {
            dispatch({
                type: "ERROR_HOME",
                payload: error
            });
        })
}


export {
    getHomeData
}